module.exports = __webpack_public_path__ + "img/join-discord-button.835ef405.svg";